import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-pwd-guard",
    templateUrl: "./pwd-guard.component.html",
    styleUrls: ["./pwd-guard.component.scss"]
})
export class PwdGuardComponent {
    public originRoute: string;

    public loginPassword: string = "";
    public pwdError: boolean = false;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.params.subscribe((params: Params) => (this.originRoute = params["origin"]));
    }

    onEnterPassword(): void {
        this.login();
    }

    login(): void {
        if (this.loginPassword === environment.testEnvGuardPwd) {
            this.pwdError = false;
            sessionStorage.setItem("testEnvPwd", this.loginPassword);
            this.router.navigate([this.originRoute]);
        } else {
            this.pwdError = true;
        }
    }
}
